import {
    CrossedCoinIcon,
    CrossedPackageIcon,
    CrossedTruckIcon,
    FlagIcon,
    FootIcon,
    OneCoinIcon,
    PacketIcon,
    RectIcon,
    ThunderIcon,
    TrophyIcon,
    TruckDeliveryIcon,
    VisitedHandshakeIcon,
    ClientSvg
} from 'assets'
import { colors } from 'styles/colors'
import { buildPotentialClientFilter } from '../villageFilterOptions'
import { TFunction } from 'i18next'
import { FilterType } from 'types/clientFiltersTypes'
import { constants, PRODUCT_CATEGORY } from 'helpers'

const { PoultryIcon, CerealIcon, VegetableIcon } = ClientSvg

const buildDeliveredYearFilters = (t: TFunction) => {
    const currentYear = new Date().getFullYear()
    const years = Array.from({ length: 4 }, (_, i) => currentYear - i)
        .reverse()
        .map((year) => ({
            icons: [
                {
                    Icon: TruckDeliveryIcon,
                    iconProps: {
                        year:
                            year < currentYear - 2
                                ? `< ${year + 1}`
                                : year.toString(),
                        width: '40',
                        height: '40'
                    }
                }
            ],
            filterName:
                year < currentYear - 2
                    ? buildPotentialClientFilter(t).BEFORE_YEAR
                    : year,
            activeColor: colors.primary
        }))
    return years
}

const potentialClientFilters = (
    t: TFunction
): { title: string; filters: FilterType[] }[] => [
    {
        title: t('fcProfile.visits').toLowerCase(),
        filters: [
            {
                icons: [
                    {
                        Icon: FootIcon,
                        iconProps: { strokeColor: colors.mediumGrey }
                    }
                ],
                filterName: buildPotentialClientFilter(t).NOT_VISITED,
                activeColor: colors.maroon
            },
            {
                icons: [{ Icon: VisitedHandshakeIcon }],
                filterName: buildPotentialClientFilter(t).VISITED,
                activeColor: colors.primary
            }
        ]
    },
    {
        title: t('fcProfile.paymentNoEnrollment').toLowerCase(),
        filters: [
            {
                icons: [{ Icon: OneCoinIcon }, { Icon: CrossedPackageIcon }],
                filterName: buildPotentialClientFilter(t).PAYMENT_NO_PACKAGE,
                isDoubleIcon: true,
                activeColor: colors.primary
            }
        ]
    },
    {
        title: t('clientDetails.delivery').toLowerCase(),
        filters: [
            {
                icons: [{ Icon: CrossedTruckIcon }],
                filterName: buildPotentialClientFilter(t).NEVER_DELIVERED,
                activeColor: colors.primary
            },
            ...buildDeliveredYearFilters(t)
        ]
    },
    {
        title: t('menu.more').toLowerCase(),
        filters: [
            {
                icons: [{ Icon: RectIcon }],
                filterName: t('clientDetails.notInterested'),
                caption: t('clientDetails.notInterested'),
                activeColor: colors.red
            },
            {
                icons: [{ Icon: FlagIcon }],
                filterName: buildPotentialClientFilter(t).DUPLICATE,
                caption: buildPotentialClientFilter(t).DUPLICATE,
                activeColor: colors.red
            }
        ]
    }
]

const clientFilters = (t: TFunction) => [
    {
        title: t('payment'),
        filters: [
            {
                icons: [{ Icon: ThunderIcon }],
                filterName: '25%',
                activeColor: colors.yellow
            },
            {
                icons: [
                    { Icon: ThunderIcon, iconProps: { size: 18 } },
                    { Icon: ThunderIcon, iconProps: { size: 18 } }
                ],
                filterName: '50%',
                activeColor: colors.yellow
            },
            {
                icons: [
                    { Icon: ThunderIcon, iconProps: { size: 18 } },
                    { Icon: ThunderIcon, iconProps: { size: 18 } },
                    { Icon: ThunderIcon, iconProps: { size: 18 } }
                ],
                filterName: '75%',
                activeColor: colors.yellow
            },
            {
                icons: [{ Icon: TrophyIcon }],
                filterName: t('status.finished'),
                activeColor: colors.purple
            }
        ]
    },
    {
        title: t('interactions.packages'),
        filters: [
            {
                icons: [
                    { Icon: PoultryIcon, iconProps: { width: 35, height: 35 } }
                ],
                filterName: PRODUCT_CATEGORY.POULTRY,
                activeColor: colors.primary
            },
            {
                icons: [
                    { Icon: CerealIcon, iconProps: { width: 100, height: 100 } }
                ],
                filterName: PRODUCT_CATEGORY.CEREAL,
                activeColor: colors.primary
            },
            {
                icons: [
                    {
                        Icon: VegetableIcon,
                        iconProps: { width: 100, height: 100 }
                    }
                ],
                filterName: PRODUCT_CATEGORY.VEGETABLE,
                activeColor: colors.primary
            }
        ]
    },
    {
        title: t('village.packageNoPayment'),
        filters: [
            {
                icons: [
                    {
                        Icon: PacketIcon,
                        iconProps: { width: 35, height: 35 }
                    },
                    { Icon: CrossedCoinIcon }
                ],
                filterName: t('village.packageNoPayment'),
                isDoubleIcon: true,
                activeColor: colors.primary
            }
        ]
    },
    {
        title: t('menu.more').toLowerCase(),
        filters: [
            {
                icons: [{ Icon: FlagIcon }],
                filterName: t('status.duplicate'),
                caption: t('status.duplicate'),
                activeColor: colors.red
            }
        ]
    }
]

export const buildFilterGroups = (t: TFunction) => ({
    [constants.VILLAGE_PAGE_TABS.PREVIOUS_CLIENT_TAB]:
        potentialClientFilters(t),
    [constants.VILLAGE_PAGE_TABS.CURRENT_CLIENT_TAB]: clientFilters(t)
})
